import {createAction, props} from "@ngrx/store";
import { Registration } from "../../interfaces/registration.interface";

const TYPE = '[Registration]';

export const GetRegistration = createAction(`${TYPE} Get Registration`);
export const SetRegistration = createAction(`${TYPE} Set Registration`, props<{reg: Registration}>());
export const LoadingRegistration = createAction(`${TYPE} Loading Registration`);
export const ResetRegistration = createAction(`${TYPE} Reset Registration`);
